import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_there_a_manual_or_automatic_emergency_alarm_system_for_all_t'

export const dataPointDefinition = {
  retracedId: 'is_there_a_manual_or_automatic_emergency_alarm_system_for_all_t',
  name: 'Is there a manual or automatic emergency alarm system (for all types of emergencies other than fire)? ',
  description:
    'An emergency alarm system ensures that the emergency (e.g. chemical spill, earthquake) can be communicated clearly and effectively to all facility staff. The system can be manual (alarm pull for an emergency) or automatic (detector of gases/fumes from chemicals that raises alarm). \r\r\n\r\r\nThe intent of this question is to ask about the presence of an alarm system for emergencies other than fire, regardless of whether one is legally required. \r\r\n\r\r\nFire alarm systems are covered separately.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14610,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
